import { useQueryClient } from '@tanstack/react-query'
import { patchConsignmentItem } from '../api/patchConsignmentItem'
import { ConsignmentItemPatch } from '../models/request'
import getConsignmentItemSuccessHandlers from './consignmentItemSuccessHandlers'

function usePatchConsignmentItem(consignmentId: number, houseConsignmentId: number) {
  const queryClient = useQueryClient()
  const { onUpdateSuccess } = getConsignmentItemSuccessHandlers(queryClient, consignmentId, houseConsignmentId)

  const patchConsignmentItemFields = async (id: number, patch: ConsignmentItemPatch) => {
    const updated = await patchConsignmentItem(id, patch)
    await onUpdateSuccess(updated)
    return updated
  }

  return {
    patchConsignmentItem: patchConsignmentItemFields,
  }
}

export default usePatchConsignmentItem
